export interface AppConfig {
  theme: string;
  colorScheme: string;
  locale: string;
}

export const APP_CONFIG: AppConfig = {
  theme: (import.meta.env.VITE_APP_THEME || "dagger") as string,
  colorScheme: (import.meta.env.VITE_COLOR_SCHEME || "default") as string,
  locale: (import.meta.env.VITE_DEFAULT_LOCALE || "es") as string,
};
